import { COLORS } from '@btime/constants'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useServiceOrdersByStatus } from './_load/ServiceOrdersByStatusLoader'
import ColumnChart from '../../../../../packages/kiti-charts/components/charts/ColumnChart'
import LineChart from '../../../../../packages/kiti-charts/components/charts/LineChart'

const SOVolumeByStatusChart = ({ widget }) => {
  const { t } = useTranslation('common')
  const data = useServiceOrdersByStatus().reduce((acc, item) => {
    return [
      ...acc,
      { ...item, type: t('widgets.openings'), value: item.openCount },
      { ...item, type: t('widgets.completions'), value: item.completedCount },
      { ...item, type: t('widgets.discontinuations'), value: item.discontinuedCount }
    ]
  }, [])

  let Component = LineChart
  switch (widget.data?.presentation) {
    case 'column':
      Component = ColumnChart
      break
  }

  const config = {
    data,
    xField: 'date',
    yField: 'value',
    seriesField: 'type',
    colorField: 'type',
    color: [COLORS.dark5, COLORS.green, COLORS.red]
  }

  return <Component {...config} />
}

export default SOVolumeByStatusChart
